import api from './api';

/**
 * Fetch all carousel items (admin view - includes inactive items)
 */
export const fetchCarouselItems = async (params = {}) => {
  // Build query string from params
  const queryParams = new URLSearchParams(params).toString();
  const endpoint = `/admin/carousel${queryParams ? `?${queryParams}` : ''}`;
  const response = await api.get(endpoint);
  return response.data;
};

/**
 * Fetch a single carousel item by ID
 */
export const fetchCarouselItem = async (id) => {
  const response = await api.get(`/admin/carousel/${id}`);
  return response.data;
};

/**
 * Create a new carousel item
 * @param {Object} data - Carousel item data
 * @param {string} data.title - Title (required)
 * @param {string} data.subtitle - Subtitle (optional)
 * @param {File} data.image - Image file (required)
 * @param {number} data.order - Display order (optional, default: 0)
 * @param {boolean} data.active - Active status (optional, default: true)
 */
export const createCarouselItem = async (data) => {
  const formData = new FormData();
  formData.append('title', data.title !== undefined && data.title !== null ? data.title : '');
  if (data.subtitle !== undefined && data.subtitle !== null) formData.append('subtitle', data.subtitle);
  if (!(data.image instanceof File)) {
    throw new Error('Please select an image file to upload.');
  }
  formData.append('image', data.image);
  if (data.order !== undefined) formData.append('order', data.order);
  if (data.active !== undefined) formData.append('active', data.active ? '1' : '0');

  // Do NOT set Content-Type: let axios set multipart/form-data with correct boundary
  const response = await api.post('/admin/carousel', formData);
  return response.data;
};

/**
 * Update an existing carousel item (title, subtitle, order, active only; image cannot be changed)
 * @param {number} id - Carousel item ID
 * @param {Object} data - title, subtitle, order, active
 */
export const updateCarouselItem = async (id, data) => {
  const payload = {
    title: data.title !== undefined && data.title !== null ? String(data.title) : '',
    subtitle: data.subtitle !== undefined && data.subtitle !== null ? String(data.subtitle) : '',
    order: data.order !== undefined ? Number(data.order) : 0,
    active: data.active !== undefined ? !!data.active : true,
  };

  const response = await api.put(`/admin/carousel/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

/**
 * Delete a carousel item
 * @param {number} id - Carousel item ID
 */
export const deleteCarouselItem = async (id) => {
  const response = await api.delete(`/admin/carousel/${id}`);
  return response.data;
};
